import { z } from 'zod';
import { refersTo } from '../common/refers-to';
import type { PropertyCategory } from '../common/property-taxonomy.schema';
import { PropertyValuationAgentOutcomeSchema } from './valuation-agent-request.schemas';
import { ValuationAgentResultSchema } from './valuation-agent-result.schemas';

// Haus, Wohnung, Grundstück — the object types the Bewertung 1a is offered for.
// Its own constant: each product's type list is that product's rule.
export const DESK_VALUATION_CATEGORIES = [
  'HOUSE',
  'APARTMENT',
  'LAND',
] as const satisfies ReadonlyArray<PropertyCategory>;

export function isDeskValuationCategory(category: PropertyCategory): boolean {
  return (DESK_VALUATION_CATEGORIES as ReadonlyArray<PropertyCategory>).includes(category);
}

export const StartDeskValuationBodySchema = z
  .object({ dealId: refersTo('deal', z.uuid()).nullable() }) // null: started on the Objekt
  .strict();
export type StartDeskValuationBody = z.infer<typeof StartDeskValuationBodySchema>;

export const DeskValuationStartedResponseSchema = z.object({
  propertyId: refersTo('property', z.uuid()),
  request: PropertyValuationAgentOutcomeSchema, // the request this call opened: kind VALUATION_1A, status OPEN
});
export type DeskValuationStartedResponse = z.infer<typeof DeskValuationStartedResponseSchema>;

// MCP only (desk_valuation_status): the app composes the same answer from the two shipped reads.
export const DeskValuationStatusSchema = z.object({
  propertyId: refersTo('property', z.uuid()),
  latestRequest: PropertyValuationAgentOutcomeSchema.nullable(), // null: never started
  current: ValuationAgentResultSchema.nullable(), // null: none delivered yet
});
export type DeskValuationStatus = z.infer<typeof DeskValuationStatusSchema>;
